<template>
  <section class="pharma-stats statistics">
    <Breadcrumbs
      :breadcrumbs="[
        { title: $t('menu.statistics'), disabled: true },
        { title: $t('menu.pharmastatistics'), disabled: true }
      ]">
    </Breadcrumbs>

    <form class="evollu-form">

      <div class="row" v-if="clusters.length">
        <div class="col-12 col-sm-5">
          <va-switch v-model="filters.showEntityStats">
            <span slot="trueTitle">{{$t('kiosks.entity')}}</span>
            <span slot="falseTitle">
              <span>
                {{$t('statistics.cluster')}}
              </span>
              <span v-if="!filters.showEntityStats && filters.cluster" @click.prevent="expandCluster = !expandCluster" class="cluster-dropdown">
                <i class="fa" :class="{'fa-chevron-up': expandCluster, 'fa-chevron-down': !expandCluster}"></i>
              </span>
            </span>
          </va-switch>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-5">
          <span v-if="filters.showEntityStats">
            <label class="form-label">{{$t('statistics.select_entity')}}:</label>
            <multiselect
              id="entities-multiselect"
              v-model="filters.entity"
              :options="entityOptions"
              track-by="id"
              :custom-label="formatedEntityLabel"
              :placeholder="!entityOptions.length ? $t('statistics.no_entities') : $t('statistics.totalValues')"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="entityOptions.length < 2"
            >
              <span slot="noResult">{{$t('patients.noResults')}}</span>
              <template slot="clear" slot-scope="props" v-if="entityOptions.length > 1 && filters.entity !== null">
                <div id="entities-multiselect-clear" class="multiselect__clear" @mousedown.prevent.stop="filters.entity = null"></div>
              </template>
            </multiselect>
          </span>

          <span v-else>
            <label class="form-label">{{$t('statistics.select_cluster')}}:</label>
            <multiselect
              id="clusters-multiselect"
              v-model="filters.cluster"
              :options="clusterOptions"
              track-by="id"
              :custom-label="formatedEntityLabel"
              :placeholder="!clusterOptions.length ? $t('statistics.no_clusters') : $t('statistics.totalValues')"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="clusterOptions.length < 2"
            >
              <span slot="noResult">{{$t('patients.noResults')}}</span>
              <template slot="clear" slot-scope="props" v-if="clusterOptions.length > 1 && filters.cluster !== null">
                <div id="clusters-multiselect-clear" class="multiselect__clear" @mousedown.prevent.stop="filters.cluster = null"></div>
              </template>
            </multiselect>
          </span>
        </div>

        <div class="col-12 col-sm-3">
          <label class="form-label">{{$t('statistics.date_field')}}:</label>
          <multiselect
            v-model="filters.dateType"
            :options="dateOptions"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
            :disabled="isLoading"
          >
            <span slot="noResult">{{$t('patients.noResults')}}</span>
            <template slot="singleLabel" slot-scope="props">
              <span class="option__name">{{ $t(`statistics.${props.option}` )}}</span>
            </template>
            <template slot="option" slot-scope="props">
              <span class="option__name">{{ $t(`statistics.${props.option}`) }}</span>
            </template>
          </multiselect>
        </div>

        <div class="col-12 col-sm-4">
          <RangeDatePicker
            id="range-date-picker"
            :label="`${$t('statistics.date_interval')}:`"
            v-model="filters.dateRange"
            placeholder="---"
            :clearable="false"
            :disabled="isLoading"
          >
          </RangeDatePicker>
        </div>
      </div>

      <div v-if="!filters.showEntityStats && filters.cluster && expandCluster" class="row mb-5">
        <div class="col-12">
          <va-badge outline v-for="(name, index) in filters.cluster.entity_names" :key="index">
            {{name}}
          </va-badge>
        </div>
      </div>
    </form>

    <div v-show="!isLoading">
      <div v-if="!entityOptions.length">
        <div class="no-data-wrapper">
          <span class="is-bold">{{$t('statistics.no_data_for_date_interval')}}</span>
        </div>
      </div>

      <div v-else class="row pharma-stats-content">
        <div class="col-sm-6 col-lg-3 pr-1 section">
          <h5 class="section-title">&nbsp;</h5>
          <div class="row">
            <div class="col-sm-6">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ sessionIds.length }}
                    </div>
                    <div class="text-center">{{$t('pharmastatistics.screenings')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-6">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ counterEntries }}
                    </div>
                    <div class="text-center">{{$t('statistics.balcony_registers')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-6">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ pharmaAppointments }}
                    </div>
                    <div class="text-center">{{$t('pharmastatistics.appointments')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-6">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ fromAppointment }}
                    </div>
                    <div class="text-center">{{$t('pharmastatistics.records_appointment')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3 pr-1 pl-1 section">
          <h5 class="section-title">{{$t('statistics.registos')}}</h5>
          <div class="row">
            <div class="col-sm-6">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ submittedNoLoss }}
                    </div>
                    <div class="text-center">{{$t('statistics.tests_no_loss')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-6 ">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ submittedLoss }}
                    </div>
                    <div class="text-center">
                      <va-popover
                        placement="bottom"
                        :message="$t('pharmastatistics.qualified_leads_tooltip')">
                        {{$t('pharmastatistics.qualified_leads')}}
                        <i class="fa fa-info-circle"></i>
                      </va-popover>
                    </div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-6">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ cancelledNoLoss }}
                    </div>
                    <div class="text-center">{{$t('statistics.cancelled_tests_no_loss')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-6">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ cancelledLoss }}
                    </div>
                    <div class="text-center">{{$t('statistics.cancelled_tests_loss')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3 pr-1 pl-1 section">
          <h5 class="section-title">{{$t('statistics.consultations')}}</h5>
          <div class="row">
            <div class="col-sm-12">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ scheduledAppointments }}
                    </div>
                    <div class="text-center">
                      <va-popover
                        placement="bottom"
                        :message="$t('statistics.consultations_go_tooltip')">
                        {{$t('pharmastatistics.consultations_total')}}
                        <i class="fa fa-info-circle"></i>
                      </va-popover>
                    </div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-4 small-stats">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number small-number">
                      <i class="text-primary stats-icon"></i>
                      {{ convertedToAppointmentCount }}
                    </div>
                    <div class="text-center">{{$t('statistics.status.100')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-4 small-stats">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number small-number">
                      <i class="text-primary stats-icon"></i>
                      {{ appointmentMissedCount }}
                    </div>
                    <div class="text-center">{{$t('statistics.status.105')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="col-sm-4 small-stats">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number small-number">
                      <i class="text-primary stats-icon"></i>
                      {{ totalAppointments }}
                    </div>
                    <div class="text-center">{{$t('statistics.consultations_made')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3 pl-1 section">
          <h5 class="section-title">{{$t('pharmastatistics.results')}}</h5>
          <div class="row">
            <div class="col-sm-12">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ qualifiedCount }}
                    </div>
                    <div class="text-center">{{$t('pyramid.lqe')}}</div>
                  </div>
                </div>
              </va-card>
            </div>

            <div class="col-sm-6">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ appointmentNotApplicableCount }}
                    </div>
                    <div class="text-center">{{$t('statistics.status.101')}}</div>
                  </div>
                </div>
              </va-card>
            </div>

            <div class="col-sm-6 ">
              <va-card>
                <div class="info-widget-inner">
                  <div class="stats">
                    <div class="stats-number">
                      <i class="text-primary stats-icon"></i>
                      {{ appointmentEntCount }}
                    </div>
                    <div class="text-center">{{$t('statistics.status.106')}}</div>
                  </div>
                </div>
              </va-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import { StatisticsService } from '@/api/LeadsService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import { PHARMA_STATS } from '@/local-storage/LocalStorageKeys'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import DashboardInfoWidgets from '../dashboard/DashboardInfoWidgets'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'

export default {
  components: {
    Breadcrumbs,
    Multiselect,
    RangeDatePicker,
    DashboardInfoWidgets
  },
  mixins: [
    MultiselectLabelFormatter
  ],
  data () {
    return {
      expandCluster: false,
      isLoading: false,
      dataset: [],
      totalValues: null,
      filters: {
        showEntityStats: true,
        entity: null,
        cluster: null,
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD')
        },
        dateType: 'created_at'
      },
      dateOptions: [
        'created_at',
        'updated_at',
        'qualified_at'
      ]
    }
  },
  methods: {
    loadBaseData () {
      this.isLoading = true
      StatisticsService.getPharmaStats(this.requestParams)
        .then(originalData => this.createDataset(originalData))
        .catch((error) => {
          console.log(error)
          this.showToast(this.$t('statistics.something_went_wrong'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    createDataset: function (data) {
      this.dataset = {}
      this.totalValues = null

      if (data.length) {
        data
          .sort((a, b) => a.id - b.id)
          .forEach(element => {
            this.dataset[element.id] = this.createDatasetEntry(element)
          })

        this.totalValues = this.calculateAggregateData(Object.keys(this.dataset))
      }
    },
    calculateAggregateData: function (entityIds) {
      let aggregate = this.createDatasetEntry()
      const keys = Object.keys(aggregate)

      entityIds.forEach(entityId => {
        if (this.dataset.hasOwnProperty(entityId)) {
          keys.forEach(key => {
            aggregate[key] += this.dataset[entityId][key]
          })
        }
      })

      return aggregate
    },
    createDatasetEntry: function (data = {}) {
      return {
        counter: 0,
        qualified: 0,
        submitted_hl: 0,
        submitted_no_hl: 0,
        cancelled_hl: 0,
        cancelled_no_hl: 0,
        from_appointment: 0,
        session_ids: [],
        pharma_appointments: 0,
        converted_to_appointment: 0,
        appointment_not_applicable: 0,
        appointment_no_sale: 0,
        appointment_possible_sale: 0,
        trial: 0,
        appointment_missed: 0,
        appointment_ent: 0,
        sale: 0,
        ...data
      }
    },
    getFullEntityById: function (id) {
      return this.fullEntities.find(e => e.id === id)
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(PHARMA_STATS)
        if (state !== null) {
          this.filters = {
            ...this.fitlers,
            ...state
          }
        }
        resolve()
      })
    }
  },
  computed: {
    ...mapGetters([
      'clusters'
    ]),
    audiologyService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    fullEntities: function () {
      return this.audiologyService ? this.audiologyService.entities : []
    },
    requestParams: function () {
      return {
        from: this.filters.dateRange.start,
        until: this.filters.dateRange.end,
        date: this.filters.dateType
      }
    },
    entityOptions: function () {
      return Object.values(this.dataset)
        .map(element => {
          let entity = this.getFullEntityById(element.id)
          return {
            id: element.id,
            name: element.name,
            cities: entity ? entity.cities : []
          }
        })
    },
    clusterOptions: function () {
      return this.clusters
        .map(cluster => {
          let entitiesWithPermissions = this.entityOptions.filter(entity => cluster.entitiesIds.some(entityId => entity.id === entityId))
          cluster.entitiesWithPermissions = entitiesWithPermissions.length
          cluster.entity_names = entitiesWithPermissions.map(e => e.name)
          return cluster
        })
        .filter(cluster => cluster.entitiesWithPermissions > 0)
    },
    stats: function () {
      if (this.filters.showEntityStats && this.filters.entity) {
        return this.dataset[this.filters.entity.id]
      } else if (!this.filters.showEntityStats && this.filters.cluster) {
        return this.calculateAggregateData(this.filters.cluster.entitiesIds)
      } else {
        return this.totalValues
      }
    },
    counterEntries: function () {
      return this.stats ? this.stats.counter : 0
    },
    submittedLoss: function () {
      return this.stats ? this.stats.submitted_hl : 0
    },
    submittedNoLoss: function () {
      return this.stats ? this.stats.submitted_no_hl : 0
    },
    cancelledLoss: function () {
      return this.stats ? this.stats.cancelled_hl : 0
    },
    cancelledNoLoss: function () {
      return this.stats ? this.stats.cancelled_no_hl : 0
    },
    convertedToAppointmentCount: function () {
      return this.stats ? this.stats.converted_to_appointment : 0
    },
    scheduledAppointments: function () {
      return this.convertedToAppointmentCount + this.totalAppointments + this.appointmentMissedCount
    },
    appointmentNotApplicableCount: function () {
      return this.stats ? this.stats.appointment_not_applicable : 0
    },
    appointmentNoSaleCount: function () {
      return this.stats ? this.stats.appointment_no_sale : 0
    },
    appointmentPossibleSaleCount: function () {
      return this.stats ? this.stats.appointment_possible_sale : 0
    },
    appointmentMissedCount: function () {
      return this.stats ? this.stats.appointment_missed : 0
    },
    appointmentEntCount: function () {
      return this.stats ? this.stats.appointment_ent : 0
    },
    trialCount: function () {
      return this.stats ? this.stats.trial : 0
    },
    buysCount: function () {
      return this.stats ? this.stats.sale : 0
    },
    totalAppointments: function () {
      return this.appointmentPossibleSaleCount +
              this.appointmentEntCount +
              this.appointmentNotApplicableCount +
              this.appointmentNoSaleCount +
              this.trialCount + this.buysCount
    },
    qualifiedCount: function () {
      return this.stats ? this.stats.qualified : 0
    },
    pharmaAppointments: function () {
      return this.stats ? this.stats.pharma_appointments : 0
    },
    fromAppointment: function () {
      return this.stats ? this.stats.from_appointment : 0
    },
    sessionIds: function () {
      return this.stats ? this.stats.session_ids : 0
    }
  },
  watch: {
    entityOptions: {
      handler: function (options) {
        if (options.length === 1) {
          this.filters.entity = options[0]
        } else if (this.filters.entity && !options.some(option => option.id === this.filters.entity.id)) {
          this.filters.entity = null
        }
      },
      immediate: true
    },
    clusterOptions: {
      handler: function (options) {
        // Multiselect did not update label unless v-model was reset to null and then set again
        const previousValue = this.filters.cluster
        this.filters.cluster = null
        let newSelectedValue = null

        if (options.length === 1) {
          newSelectedValue = options[0]
        } else if (previousValue) {
          newSelectedValue = options.find(option => option.id === previousValue.id) || null
        }

        this.$nextTick(() => {
          this.filters.cluster = newSelectedValue
        })
      },
      immediate: true
    },
    filters: {
      handler: function () {
        LocalStorageHelper.set(PHARMA_STATS, this.filters)
      },
      deep: true
    },
    'filters.showEntityStats': function (value) {
      if (!value && !this.clusters.length) {
        this.filters.showEntityStats = true
      }
    },
    requestParams: function (value) {
      this.loadBaseData()
    },
  },
  mounted () {
    this.loadLocalStorage()
      .then(() => {
        this.loadBaseData()
      })
  }
}
</script>

<style lang="scss">
.pharma-stats {
  .pharma-stats-content {
    .va-card__body {
      overflow-x: unset;
    }
    .va-card.dashboard-stats-widgets {
      -webkit-box-shadow: 0 0 3px 0 rgba(52, 56, 85, 0.25);
      box-shadow: 0 0 3px 0 rgba(52, 56, 85, 0.25);
      background-color: transparent;
    }
    .va-card:not(.dashboard-stats-widgets) {
      height: calc(100% - 1.5rem);
    }
    .info-widget-inner {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 100%;
      min-height: 100px !important;

      &.has-chart {
        justify-content: space-between;
      }

      .stats {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
        min-height: 110px;
      }
    }

    .dashboard-stats-widgets .row>div {
      padding-left: 0.3rem !important;
      padding-right: 0.3rem !important;
    }
  }

  .stats-number {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 2.625rem;
    margin-bottom: 0.5rem;

    &.small-number {
      font-size: 1.8rem;
    }

    @media (min-width: 1600px) {
      &.small-number {
        font-size: 1.5rem;
      }
    }

    .stats-icon {
      font-size: 1.5625rem;
      position: absolute;
      top: 0.625rem;
      left: -1.25rem;

      &.icon-wide {
        left: -1.875rem;
      }
    }
  }

  .final-status .widget {
    background: #d8dcdc;
  }

  .cancelled-status .widget {
    background: #d8dcdc;
    color: #7d8888;
  }

  .final-status-success .widget {
    background: #5dceb3;
  }
}
</style>
